import React from 'react'
import "./Team.scss"
import frame1 from "../../../assets/images/frame1.png"
import frame2 from "../../../assets/images/frame2.png"
import frame3 from "../../../assets/images/frame3.png"

import facebook from "../../../assets/images/facebook.png"
import linkedin from "../../../assets/images/linkedin.png"
import twitter from "../../../assets/images/twitter.png"
import instagram from "../../../assets/images/instagram.png"
const Team = () => {
    return (
        <div className='teammain'>
            <div className="teamtop">
                <h3>Team</h3>
                <h5>Meet Our Dynamic Team</h5>
            </div>

            <div className="teambot">

                <div className="card1">
                    <div className="cardback">
                        <img src={frame1} alt="" />
                    </div>
                    <div className="cardcont">
                        <h2>Montel Alekender</h2>
                        <p>
                            Manager
                        </p>
                        <div className="sociallink">
                            <div><img src={facebook} alt="" /></div>
                            <div><img src={linkedin} alt="" /></div>
                            <div><img src={twitter} alt="" /></div>
                            <div><img src={instagram} alt="" /></div>
                        </div>
                    </div>
                </div>
                <div className="card1">
                    <div className="cardback">
                        <img src={frame2} alt="" />
                    </div>
                    <div className="cardcont">
                        <h2>Qaniel Burnside</h2>
                        <p>
                            Co-Founder,CTO
                        </p>
                        <div className="sociallink">
                            <div><img src={facebook} alt="" /></div>
                            <div><img src={linkedin} alt="" /></div>
                            <div><img src={twitter} alt="" /></div>
                            <div><img src={instagram} alt="" /></div>
                        </div>
                    </div>
                </div>
                <div className="card1">
                    <div className="cardback">
                        <img src={frame3} alt="" />
                    </div>
                    <div className="cardcont">
                        <h2>Liliana Moore</h2>
                        <p>
                            Business Development
                        </p>
                        <div className="sociallink">
                            <div><img src={facebook} alt="" /></div>
                            <div><img src={linkedin} alt="" /></div>
                            <div><img src={twitter} alt="" /></div>
                            <div><img src={instagram} alt="" /></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Team
